import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
let widget = class widget extends Vue {
    get image() {
        if (this.profile.image) {
            return "data:image/jpeg;base64," + this.profile.image;
        }
        return false;
    }
};
tslib_1.__decorate([
    Prop({ required: true })
], widget.prototype, "profile", void 0);
tslib_1.__decorate([
    Prop({ default: "35px" })
], widget.prototype, "size", void 0);
widget = tslib_1.__decorate([
    Component({})
], widget);
export default widget;
